import { render } from "./ScriptsList.vue?vue&type=template&id=1090b546&scoped=true&ts=true"
import script from "./ScriptsList.vue?vue&type=script&lang=ts"
export * from "./ScriptsList.vue?vue&type=script&lang=ts"

import "./ScriptsList.vue?vue&type=style&index=0&id=1090b546&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1090b546"]])

export default __exports__